import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import PropTypes from "prop-types";
import React from "react";

const PayPalPaymentButtons = ({
  disabled = false,
  fundingSource = "paypal",
  onApprove = () => {},
  onCancel = () => {},
  onError = () => {},
  totalDonationAmount = "0",
}) => {
  usePayPalScriptReducer();
  return (
    <PayPalButtons
      disabled={disabled}
      forceReRender={[totalDonationAmount]}
      fundingSource={fundingSource}
      style={{ layout: "vertical", label: "donate" }}
      createOrder={(data, actions) => {
        return actions.order
          .create({
            purchase_units: [
              {
                amount: {
                  value: totalDonationAmount,
                  breakdown: {
                    item_total: {
                      currency_code: "USD",
                      value: totalDonationAmount,
                    },
                  },
                },
                items: [
                  {
                    name: "chicago-regatta-leaderboard",
                    quantity: "1",
                    unit_amount: {
                      currency_code: "USD",
                      value: totalDonationAmount,
                    },
                    category: "DONATION",
                  },
                ],
              },
            ],
            application_context: {
              shipping_preference: "NO_SHIPPING",
            },
          })
          .then((orderId) => {
            return orderId;
          });
      }}
      onApprove={onApprove}
      onCancel={onCancel}
      onError={onError}
    />
  );
};

PayPalPaymentButtons.propTypes = {
  disabled: PropTypes.bool,
  fundingSource: PropTypes.string,
  onApprove: PropTypes.func,
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  totalDonationAmount: PropTypes.string,
};

export default PayPalPaymentButtons;
